export default __webpack_public_path__ + "static/media/spinner.29181c59.gif";